import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { DashboardInformationDetails } from '@/@types/responses/dashboard_information/DashboardInformationDetails'
import { MiscellaneousService } from './miscellaneous.service'

export class DashboardInformationService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public getDashboardInformation(): Promise<DashboardInformationDetails> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/dashboard-information`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return new DashboardInformationDetails(json)
    })
  }
}
